class ImageSwitcher extends HTMLElement {
  constructor() {
    super();
    this.isLipPage = window.location.href.includes("collections/lip");
    //   this.resizeHandler = this.moveElement.bind(this);
    this.current_view_desktop_t = this.querySelector(
      "label.current-view-desktop"
    ).textContent;
    this.current_view_mobile_t = this.querySelector(
      "label.current-view-mobile"
    ).textContent;
    this.product_images_t = this.querySelector(
      "label.product-images"
    ).textContent;
  }

  connectedCallback() {
    this.switchLabelDesktop = this.querySelector(".switch-label.desktop");
    this.switchLabelMobile = this.querySelector(".switch-label.mobile");
    this.switchInput = this.querySelector("#view-switch");

    this.switchInput.addEventListener(
      "change",
      this.handleSwitchChange.bind(this)
    );

    // this.moveElement();

    window.addEventListener("resize", this.resizeHandler);
  }

  disconnectedCallback() {
    this.switchInput.removeEventListener(
      "change",
      this.handleSwitchChange.bind(this)
    );
    window.removeEventListener("resize", this.resizeHandler);
  }

  handleSwitchChange() {
    if (this.switchInput.checked) {
      this.switchLabelDesktop.textContent = this.isLipPage
        ? `${this.current_view_desktop_t} Lippen`
        : `${this.current_view_desktop_t} Auge`;
      this.switchLabelMobile.textContent = this.isLipPage
        ? `${this.current_view_mobile_t} Lippen`
        : `${this.current_view_mobile_t} Auge`;
    } else {
      this.switchLabelDesktop.textContent = `${this.current_view_desktop_t} ${this.product_images_t}`;
      this.switchLabelMobile.textContent = `${this.current_view_mobile_t} ${this.product_images_t}`;
    }
    this.swapClassNames();
  }

  moveElement() {
    let collectionRoot = document.getElementById("collection-root");
    let collectionRoot2 = document.querySelector(
      ".collection--navigation--layout"
    );
    let switchContainer = this;

    if (window.matchMedia("(min-width: 987px)").matches) {
      if (!collectionRoot2.contains(switchContainer)) {
        collectionRoot2.prepend(switchContainer);
      }
    } else {
      if (!collectionRoot.contains(switchContainer)) {
        collectionRoot.parentNode.insertBefore(switchContainer, collectionRoot);
      }
    }
  }

  swapClassNames() {
    let hoverImages = document.querySelectorAll(".product--hover-image");
    let images = document.querySelectorAll(".product--image");

    hoverImages.forEach(function (element) {
      element.classList.remove("product--hover-image");
      element.classList.add("product--image-temp");
    });

    images.forEach(function (element) {
      element.classList.remove("product--image");
      element.classList.add("product--hover-image");
    });

    let tempImages = document.querySelectorAll(".product--image-temp");
    tempImages.forEach(function (element) {
      element.classList.remove("product--image-temp");
      element.classList.add("product--image");
    });
  }
}

customElements.define("image-switcher", ImageSwitcher);
